import React from 'react';
import Immutable from 'immutable';

import { withGlobalContext } from '../data/globalcontext';
import { ModuleBodySection, ModuleHeader, ModuleHeaderBlock, ModuleHeaderSection } from '../blocks/modulesections';
import { Form, FormItem, ParentBoundComponent, styled, LookupInput, NumberUtils, DateUtils, Icon, webapi, REPORTED_EXCEPTION,   } from 'ps-gui';
import { getColumnText, getFormItemLabel, getPhrase } from '../data/phrases';

import { ReactComponent as ModuleLogo } from '../svg/document.svg';
import DocumentModel from './documentmodel';
import { downloadFile, getGlobalContextChangeChecker, parseRoleId } from './utils';
import Message from '../blocks/message';

const Wrapper = styled.div`
`;

const EMPTY_MAP = Immutable.Map({});
const EMPTY_LIST = Immutable.List([]);

const formatAmount = NumberUtils.getFixedDecimalFormatNumber(2);

class DocumentModule extends ParentBoundComponent {

	constructor() {
		super();
		this.setRoleId = this.setRoleId.bind(this);
		this.setDistributionPeriodId = this.setDistributionPeriodId.bind(this);

		this.checkGlobalContextChange = getGlobalContextChangeChecker(this);
	}

	async download(objectIds, fileName, zip) {
		if (typeof objectIds === 'string') {
			objectIds = [objectIds];
		} else {
			objectIds = objectIds.toJS();
		}
		const data = this.getData();
		const role = parseRoleId(data.get('roleId'));
		let pars = {
			objectIds,
			year: parseInt(data.get('distributionPeriodId')),
			partyId: role.partyId,
			roleTypeId: role.roleTypeId,
			zip
		};
		const fileId = await webapi.execute('/api/elo/download', pars);
		if (fileId === REPORTED_EXCEPTION) {
			return;
		}
		console.log(fileId);
		downloadFile(fileId, fileName);
	}

	async setRoleId(roleId) {
		let model = this.getModel().setRoleId(roleId);
		this.setModel(await model.loadData());
	}

	async setDistributionPeriodId(distributionPeriodId) {
		let model = this.getModel().setDistributionPeriodId(distributionPeriodId);
		this.setModel(await model.loadData());
	}

	getModel() {
		return new DocumentModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	componentDidMount() {
		this.checkGlobalContextChange();
	}

	componentDidUpdate(prevProps) {
		this.checkGlobalContextChange(prevProps);
	}

	renderNoData() {
		return (
			<Message>
				{getPhrase('documentNoDataMessage')}
			</Message>
		);
	}

	renderRowGroups(rowGroups) {
		if (rowGroups?.size === 0) {
			return null;
		}
		return (
			<RowGroups>
				{
					rowGroups.map((rg, rgIndex) => {
						return (
							<div className='rowGroup' key={rgIndex}>
								<div className='header'>
									<span className='date'>
										{getPhrase('paidOn')} {DateUtils.formatDate(rg.get('paymentDate'))}
										<Icon
											active
											name="downloadFile"
											onMouseDown={e => {
												e.preventDefault();
												this.download(rg.get('rows').map(row => row.get('objectId')), rg.get('paymentDate') + '.zip', true);
											}}
										/>
									</span>
								</div>
								<div className='rows'>
									{
										rg.get('rows').map((row, rowIndex) => {
											const documentNo = row.get('documentNo');
											const amount = row.get('amount');
											const closureIsLast = !(documentNo || amount);
											return (
												<div className='row' key={rowIndex}>
													<span className='name'>
														<div className='label'>{getFormItemLabel('documentName')}</div>
														<span
															className='tight'
															onMouseDown={e => {
																e.preventDefault();
																this.download(row.get('objectId'), row.get('name'), false);
															}}
														>
															{row.get('name')}
														</span>
													</span>
													<span className={'closureId' + (closureIsLast ? ' last' : '')}>
														<div className='label'>{row.get('closureId') ? getFormItemLabel('closureId') : null}</div>
														{row.get('closureId')}
													</span>
													{
														!closureIsLast && (
															<>
																<span className='documentNo'>
																	<div className='label'>{documentNo ? getFormItemLabel('documentNo') : null}</div>
																	{documentNo}
																</span>
																<span className='amount'>
																	<div className='label'>
																		{amount ? getFormItemLabel('amount') : null}
																		{
																			amount && (
																				<span className='currency'>{getPhrase('czk')}</span>
																			)
																		}
																	</div>
																	{formatAmount(amount)}
																	{
																		amount && (
																			<span className='currency'>{getPhrase('czk')}</span>
																		)
																	}
																</span>
															</>
														)
													}
												</div>
											);
										})
									}
								</div>
							</div>
						);
					})
				}
			</RowGroups>
		);
	}

	renderInvoiceDocuments(invoiceDocuments) {
		if (invoiceDocuments?.size === 0) {
			return null;
		}
		return (
			<RowGroups>
				<div className='rowGroup'>
					<div className='header'>
						<span className='date'>
							{getPhrase('invoiceDocumentsHeader')}
							<Icon
								active
								name="downloadFile"
								onMouseDown={e => {
									e.preventDefault();
									this.download(invoiceDocuments.map(row => row.get('objectId')), getPhrase('invoiceDocumentsHeader') + '.zip', true);
								}}
							/>
						</span>
					</div>
					<div className='rows'>
						{
							invoiceDocuments.map((row, rowIndex) => {
								const documentNo = row.get('documentNo');
								const amount = row.get('amount');
								const closureIsLast = !(documentNo || amount);
								return (
									<div className='row' key={rowIndex}>
										<span className='name'>
											<div className='label'>{getFormItemLabel('documentName')}</div>
											<span
												className='tight'
												onMouseDown={e => {
													e.preventDefault();
													this.download(row.get('objectId'), row.get('name'), false);
												}}
											>
												{row.get('name')}
											</span>
										</span>
										<span className={'closureId' + (closureIsLast ? ' last' : '')}>
											<div className='label'>{row.get('closureId') ? getFormItemLabel('closureId') : null}</div>
											{row.get('closureId')}
										</span>
										{
											!closureIsLast && (
												<>
													<span className='documentNo'>
														<div className='label'>{documentNo ? getFormItemLabel('documentNo') : null}</div>
														{documentNo}
													</span>
													<span className='amount'>
														<div className='label'>
															{amount ? getFormItemLabel('amount') : null}
															{
																amount && (
																	<span className='currency'>{getPhrase('czk')}</span>
																)
															}
														</div>
														{formatAmount(amount)}
														{
															amount && (
																<span className='currency'>{getPhrase('czk')}</span>
															)
														}
													</span>
												</>
											)
										}
									</div>
								);
							})
						}
					</div>
				</div>
			</RowGroups>
		);
	}

	render() {
		const model = this.getModel();
		const data = this.getData();
		const roleId = data.get('roleId');
		const roleLookup = data.get('roleLookup');
		if (!roleLookup) {
			return null;
		}
		const dpLookup = model.getDistributionPeriodLookup();
		const selectedTabId = data.get('selectedTabId') || 'search';
		const languageTimestamp = model.getLanguageTimestamp();
		const payments = data.get('payments');
		const invoiceDocuments = data.get('invoiceDocuments');
		const hasData = payments.size > 0 || invoiceDocuments.size > 0;

		if (dpLookup.isEmpty()) {
			return this.renderNoData();
		}

		return (
			<Wrapper>
				<ModuleHeaderSection className="noBorder">
					<ModuleHeaderBlock>
						<ModuleHeader>{getPhrase('Document')}</ModuleHeader>
						<Form virtual horizontal>
							<FormItem label={getColumnText('role')} fixedWidth="540px" marginRight="30px">
								<LookupInput
									getText={roleLookup.getText}
									getRows={roleLookup.getRows}
									combo
									mandatory
									value={roleId}
									onChange={this.setRoleId}
									textRefreshTimestamp={languageTimestamp}
								/>
							</FormItem>
							{
								dpLookup &&
								<FormItem label={getColumnText('year')} fixedWidth="120px">
									<LookupInput
										getText={dpLookup.getText}
										getRows={dpLookup.getRows}
										combo
										mandatory
										value={data.get('distributionPeriodId')}
										onChange={this.setDistributionPeriodId}
										textRefreshTimestamp={languageTimestamp}
									/>
								</FormItem>

							}
						</Form>
					</ModuleHeaderBlock>
					<ModuleHeaderBlock>
						<ModuleLogo />
					</ModuleHeaderBlock>
				</ModuleHeaderSection>
				<ModuleBodySection top="-16px">
					{
						hasData ? (
							<>
								{this.renderInvoiceDocuments(invoiceDocuments)}
								{this.renderRowGroups(payments)}
							</>
						) : this.renderNoData()
					}
				</ModuleBodySection>
			</Wrapper>
		);
	}
}

const Block24 = styled.div`
	height: 24px;
`;

const RowGroups = styled.div`
	padding: 4px 16px;
	.rowGroup {
		margin-bottom: 24px;
		.header {
			.date {
				font-size: 18px;
				font-weight: 500;
				color: ${props => props.theme.disabledTextColor};

				.icon {
					//display: none;
					position: relative;
					top: -2px;
					margin-left: 8px;
				}

			}
			&:hover {
				.date {
					.icon {
						display: inline-block;
					}
				}
			}
			margin-bottom: 8px;
		}
		.rows {
			padding-left: 32px;
			.row {
				padding: 4px 0px;
				cursor: default;
				&:hover {
					background: ${props => props.theme.tableRowHoverBackground};
				}
				> span {
					padding: 2px 16px;
					display: inline-block;

				}
				.label {
					font-size: 80%;
					color: ${props => props.theme.disabledTextColor};
					opacity: 0.7;
					.currency {
						font-size: 100%;
						visibility: hidden;
						display: none;
					}
				}
				.name {
					width: 40%;
					.tight {
						cursor: pointer;
						.icon {
							display: none;
							position: relative;
							top: -2px;
							margin-left: 8px;
						}
						&:hover {
							text-decoration: underline;
							.icon {
								display: inline-block;
							}
						}
					}
				}
				.closureId {
					width: 20%;
					color: ${props => props.theme.disabledTextColor};
					&.last {
						width: auto;
					}
				}
				.documentNo {
					width: 20%;
					color: ${props => props.theme.disabledTextColor};
				}
				.amount {
					width: 20%;
					text-align: right;
					color: ${props => props.theme.disabledTextColor};
				}
				.currency {
					margin-left: 2px;
					font-size: 80%;
					opacity: 0.7;
				}

			}
		}
	}
`;

export default withGlobalContext(DocumentModule);



